import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#000\" d=\"M23.064 7.347C21.247 3.03 16.978 0 12.001 0a11.96 11.96 0 0 0-8.485 3.515L6.52 7.347z\"></path><path fill=\"#496E2D\" d=\"m6.555 16.608-3.04 3.876a11.96 11.96 0 0 0 8.486 3.515c4.994 0 9.275-3.051 11.082-7.391z\"></path><path fill=\"#A2001D\" d=\"M2.61 8.826v6.304h20.977c.27-.998.414-2.047.414-3.13 0-1.099-.148-2.163-.425-3.174z\"></path><path fill=\"#0052B4\" d=\"M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z\"></path><path fill=\"#FFDA44\" d=\"m3.909 9.016 1.465 2.044L7.77 10.3 6.28 12.323l1.465 2.044-2.387-.792-1.49 2.024.015-2.514-2.386-.793 2.397-.761z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }